import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initialResourcesReady } from "./i18n";

document
  .querySelectorAll('script[data-prerender-structured-data="true"]')
  .forEach((script) => script.remove());

const root = ReactDOM.createRoot(document.getElementById("root"));

// Block initial render until the correct language resources are loaded.
// EN is bundled synchronously; for ES/PL/SV (detected from URL path or
// localStorage) we await the dynamic chunk so the first paint is in the
// right language and Helmet immediately writes the right <title>, <meta>
// and <html lang>.
initialResourcesReady.finally(() => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
